class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', () => this.close());
    this.setHeaderCartIconAccessibility();

    const referrer = document.referrer;
    if(referrer.includes("/cart")) {
        this.open()
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help


       // Delay in milliseconds (e.g., 5000 = 5 seconds)
  function initMainGridSwiper(selector) {
  if (document.querySelector(selector)?.swiper) return; // already initialized

  const el = document.querySelector(selector);
  if (!el) return;

  new Swiper(selector, {
    loop: false,
    grabCursor: true,
    spaceBetween: 11,
    slidesPerGroup: 1,
    slidesPerView: 1.225,
    watchSlidesProgress: false,
    draggable: true,
    autoHeight: false,
    watchOverflow: true,
    threshold: 10,
    freeMode: 0,
    observer: true,
    observeParents: true,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: false,
      eventsTarget: selector
    },
    breakpoints: {
      0: { slidesPerView: 1.05, spaceBetween: 11 },
      750: { slidesPerView: 1.225, spaceBetween: 11 }
    }
  });

  console.log(`Swiper initialized for ${selector}`);
}

// Function to observe DOM for swiper elements
const observer = new MutationObserver(() => {
  initMainGridSwiper('.main__grid_swiper');
  initMainGridSwiper('.main__grid_swiper_new');
});

// Start observing DOM changes
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// In case elements already exist at page load
initMainGridSwiper('.main__grid_swiper');
initMainGridSwiper('.main__grid_swiper_new');

     

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close(isMonogramDrawer = false) {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    
    if(isMonogramDrawer && typeof isMonogramDrawer === "boolean") return;
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

      document.querySelectorAll("[js-properties-field]")?.forEach(el => el.setAttribute("disabled", "disabled"));
      document.querySelectorAll("[js-combo-add-btn]")?.forEach(el => el.classList.remove("is-remove"));

      if(document.querySelector("[js-gift-price]")) {
        document.querySelector("[js-gift-price]").textContent = "";
      }

      const monogramInitials = document.querySelector("[js-monogram-initials]")
      const placeholderInitialsLabel = monogramInitials?.getAttribute("data-initial-placeholder-label");
      const initialCharacter = monogramInitials?.getAttribute("data-initial-character");

      if(monogramInitials && placeholderInitialsLabel && initialCharacter) {
        monogramInitials.innerHTML = `${placeholderInitialsLabel} ${initialCharacter}`;
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);